<template>
  <DBox 
    :id="'cmp-settings-general-territory'" 
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add_new')} ${$t('territory')}`"
    @add_click="onAddNewTerritory"
  
  >
    <DList
      :items="territories"
      :primaryKey="'territory_id'"
      :labelKey="'territory_name'"
      @delete="onTerritoryDelete"
      @item_click="onTerritoryItemClick"
    />
  </DBox>
</template>


<script>
import DBox from '@dtplugins/dbox/dbox';
import DList from '@dtplugins/list/dlist';
import { ConfirmationService } from '../../../../dt-plugins/confirmation/confirmation.service';
import { confirmDelete } from "@/dt-plugins/confirmation/confirmation-common";

export default {
  components: {
    DBox,
    DList,
  },
  props: ['territories'],
  methods: {
    onTerritoryDelete:async function(item) {
      const confirmationResult = await confirmDelete(
        "Territory",
        item.territory_name
      );
      if (confirmationResult === "OK") {
        this.$emit('delete', item);
      }
      // ConfirmationService.create({
      //   subject: `Do you really want to delete the Territory ?`,
      //   model: true,
      //   width: 500,
      //   completed: res => {
      //     switch(res) {
      //       case 'OK': {
      //         this.$emit('delete', item);
      //         break;
      //       }
      //     }
      //   }
      // });
    },
    onTerritoryItemClick: function(item) {
      this.$emit('item_click', item);
    },
    onAddNewTerritory: function() {
      this.$emit('add_new', true);
    }
  }
};
</script>

<style lang="scss">
  .cmp-settings-general-territory {
    .dt-list-item--text{
      font-weight: 600;
    }
  }
</style>